import { IconProps } from '@app/components/Atoms/Icon'
import React from 'react'

export const RiskIcon: React.FC<IconProps> = ({ onClick, className, size, active, ...rest }) => {
  return (
    <svg
      {...rest}
      className={className}
      onClick={onClick}
      width={size || '41'}
      height={size || '41'}
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_163_656)">
        <path
          d="M22.39 28.4149C22.27 28.2899 22.14 28.1799 21.995 28.0899C21.63 27.8499 21.195 27.7099 20.725 27.7099C20.255 27.7099 19.82 27.8499 19.455 28.0949C19.31 28.1899 19.18 28.2999 19.06 28.4199C18.91 28.5749 18.785 28.7599 18.68 28.9499C18.51 29.2749 18.4 29.6349 18.4 30.0249C18.4 31.3049 19.44 32.3449 20.72 32.3449C22 32.3449 23.04 31.3049 23.04 30.0249C23.04 29.6349 22.935 29.2699 22.76 28.9499C22.655 28.7549 22.535 28.5749 22.385 28.4199L22.39 28.4149Z"
          fill={active ? '#0B2948' : 'white'}
        />
        <path
          d="M20.75 9.73486C16.685 9.73486 13.375 13.0449 13.375 17.1099C13.375 18.0049 14.1 18.7299 14.995 18.7299C15.89 18.7299 16.615 18.0049 16.615 17.1099C16.615 15.7749 17.25 14.5899 18.235 13.8349C18.935 13.2949 19.805 12.9749 20.755 12.9749C21.705 12.9749 22.54 13.2849 23.235 13.8049C24.24 14.5599 24.895 15.7599 24.895 17.1099C24.895 18.1899 24.48 19.1749 23.8 19.9099L23.49 23.9549C26.205 22.8649 28.13 20.2099 28.13 17.1099C28.13 13.0399 24.82 9.73486 20.755 9.73486H20.75Z"
          fill={active ? '#0B2948' : 'white'}
        />
        <path
          d="M21.045 13.9848C20.94 13.9748 20.83 13.9698 20.725 13.9698C20.725 13.9698 20.725 13.9698 20.72 13.9698C20.6 13.9698 20.48 13.9798 20.36 13.9948C20.36 13.9948 20.355 13.9948 20.35 13.9948C20.23 14.0098 20.115 14.0298 19.995 14.0598C19.995 14.0598 19.995 14.0598 19.99 14.0598C19.75 14.1198 19.52 14.2048 19.305 14.3198C19.27 14.3348 19.235 14.3548 19.195 14.3748C18.86 14.5648 18.565 14.8198 18.325 15.1148L18.645 19.3098L18.795 21.3048L19.235 27.0848C19.685 26.8698 20.185 26.7398 20.72 26.7398C21.255 26.7398 21.75 26.8698 22.205 27.0848L22.42 24.2498L22.64 21.3848L22.69 20.7198L22.8 19.3098L23.13 15.1298C22.63 14.4998 21.885 14.0698 21.045 13.9848Z"
          fill="#61C9DC"
        />
      </g>
      <defs>
        <clipPath id="clip0_163_656">
          <rect width="24" height="24" fill="white" transform="translate(8.5 8.54987)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default RiskIcon
